<template>
    <v-container fluid>
        <v-alert color="error" v-if="error">{{ error }}</v-alert>
        <v-dialog v-if="!passwordCompare" v-model="passwordDialog" persistent max-width="500">
            <v-card>
                <v-card-title v-if="deal !== null && (deal.STAGE_ID === 'C30:1' || deal.STAGE_ID === 'C30:2' || deal.STAGE_ID === 'C30:WON')" class="headline">Введите пароль доступа:</v-card-title>
                <v-card-text>
                    <v-text-field v-if="deal !== null && (deal.STAGE_ID === 'C30:1' || deal.STAGE_ID === 'C30:2' || deal.STAGE_ID === 'C30:WON')" v-model="password" @keyup.enter="checkPassword"></v-text-field>
                    <!--<v-row v-else>
                        <v-col cols="12" class="title">ОТЧЕТ У МЕНЕДЖЕРА ПРОЕКТА ТП</v-col>
                    </v-row>-->
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="deal !== null && (deal.STAGE_ID === 'C30:1' || deal.STAGE_ID === 'C30:2' || deal.STAGE_ID === 'C30:WON')" color="green darken-1" text @click="checkPassword">Войти</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="!!passwordCompare && report">
            <v-snackbar v-model="snackbar" color="success" top :timeout="3000" multi-line>
                Менеджер по сопровождению вашей станции уведомлен!
                <v-btn color="white" text @click="snackbar = false">Закрыть</v-btn>
            </v-snackbar>

            <v-dialog v-model="sendToAccountDialog" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline">Отправить менеджеру уведомление?</v-card-title>
                    <v-card-text>После того как вы отправите уведомление, вы не сможете оставлять комментарии и влиять на результат отчета.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="sendToAccountDialog = false">Не отправлять</v-btn>
                        <v-btn color="red darken-1" text @click="sendToAccount">Отправить менеджеру</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <simple-loader-dialog :show="loader" :text="loaderText"></simple-loader-dialog>
            <v-card>
                <v-toolbar flat dense v-if="report !== null">
                    <span v-if="report && report.dealData">{{ report.dealData.address }}</span>
                    <v-spacer></v-spacer>
                    <div style="display: inline-block" class="pt-5 mr-5">
                        <v-switch v-model="report.testInspection" v-if="!!report.testInspection" disabled label="Тестовая проверка"></v-switch>
                    </div>
                    <div style="display: inline-block" class="pt-5 mr-2">
                        <v-switch v-model="report.firstInspection" v-if="!!report.firstInspection" disabled label="Первичная проверка"></v-switch>
                    </div>
                    <div style="display: inline-block" class="pt-5 mr-2">
                        <v-btn color="info" :href="`https://sbotapi.fitauto.ru/v3/reports/tp/${dealID}/report.pdf`"
                               target="_blank">PDF Отчет
                        </v-btn>
                    </div>
                    <div style="display: inline-block" class="pt-5 mr-2" v-if="mode === 'franch'">
                        <v-btn @click="sendToAccountDialog = true" color="success">Акт проработан, сообщить менеджеру по сопровождению</v-btn>
                    </div>
                    <div style="display: inline-block" class="pt-5 mr-2" v-if="mode === 'account'">
                        <v-btn @click="returnToFranch" color="success" :disabled="!report.sendToAccount || deal.STAGE_ID !== 'C30:1'">Вернуть акт в СТО</v-btn>
                    </div>
                </v-toolbar>
                <v-card-text v-if="deal !== null">
                    <v-tabs v-model="tab" center-active background-color="deep-purple accent-4" class="elevation-2" dark
                            v-if="report !== null">

                        <v-tab href="#tab-main">Информация о проверке</v-tab>
                        <v-tab href="#tab-report">Основной отчет</v-tab>
                        <v-tab href="#tab-docs">Документы</v-tab>
                        <v-tab href="#tab-final">Итоги</v-tab>
                        <v-tab href="#tab-photo">Фото</v-tab>
                        <v-tab href="#tab-audio">Аудио</v-tab>
                        <v-tab href="#tab-video">Видео</v-tab>
                        <v-tab href="#tab-download" v-if="mode === 'account'">Скачивание файлов</v-tab>
                        <v-tab-item value="tab-main">
                            <v-card flat tile>
                                <v-card-text>
                                    <v-simple-table v-if="report !== null">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left" width="350">Информация о проверке</th>
                                                <th class="text-left"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Адрес СТО:</td>
                                                <td>{{ report.dealData.address }}</td>
                                            </tr>
                                            <tr>
                                                <td>Дата проведения проверки:</td>
                                                <td>{{ report.dealData.real_start_date }}</td>
                                            </tr>
                                            <tr v-for="item in report.head" :key="item.answer_id">
                                                <td>{{ item.question }}</td>
                                                <td>{{ item.answer }}</td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left" width="350">Дополнительные вопросы</th>
                                                <th class="text-left"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="item in report.additional" :key="item.answer_id">
                                                <td>{{ item.question }}</td>
                                                <td>
                                                    {{ item.answer }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-report">
                            <v-card flat tile>
                                <v-card-text>
                                    <basic-table :deletemode="deleteMode" v-model="report.points" @change="saveReport" :stage="deal.STAGE_ID" :images="images" :mode="mode"></basic-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-docs">
                            <v-card flat tile>
                                <v-card-text>
                                    <docs-table :deletemode="deleteMode" v-model="report.points" @change="saveReport" :stage="deal.STAGE_ID" :images="images" :mode="mode"></docs-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-final">
                            <v-card flat tile>
                                <v-card-text>
                                    <report-percentage v-model="report" @change="saveReport" :mode="mode"></report-percentage>
                                    <penalty-table v-model="report" @change="saveReport" :mode="mode" :stage="deal.STAGE_ID"></penalty-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-photo">
                            <v-card flat tile>
                                <v-card-text>
                                    <tp-media-images v-model="report.files" :stage="deal.STAGE_ID" :mode="mode"></tp-media-images>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-audio">
                            <v-card flat tile>
                                <v-card-text>
                                    <audio-card v-model="report.files" @change="saveReport" :mode="mode" :deal="dealID"></audio-card>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-video">
                            <v-card flat tile>
                                <v-card-text>
                                    <video-card v-model="report.files" :mode="mode" :stage="deal.STAGE_ID" :deal="dealID"></video-card>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-download" v-if="mode === 'account'">
                            <v-card flat>
                                <v-row>
                                    <v-col cols="4"></v-col>
                                    <v-col cols="4">
                                        <v-list two-line>
                                            <v-list-item v-for="(item, i) in filesInPoints" :key="i">
                                                <v-list-item-content>
                                                    <v-list-item-title class="title">
                                                        {{ item.question }}
                                                    </v-list-item-title>
                                                    <div v-if="typeof item.sto_file === 'string'"><a :href="item.sto_file">Скачать файл</a></div>
                                                    <div v-else v-for="(file, j) in item.sto_file"><a :href="file">Скачать файл {{ j + 1 }}</a></div>
                                                    <v-divider></v-divider>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                    <v-col cols="4"></v-col>
                                </v-row>
                            </v-card>

                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </div>
        <v-dialog v-if="report && !!passwordCompare && mode === 'franch'" v-model="report.sendToAccount" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Отчет отправлен менеджеру!</v-card-title>
                <v-card-text>После того как менеджер по сопровождению проверит отчет, вам отправят акт проверки!</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
  import VideoCard from '../components/tpreport/videoCard'
  import AudioCard from '../components/tpreport/audioCard'
  import TpMediaImages from '../components/tpreport/tpMediaImages'
  import BasicTable from '../components/tpreport/basicTable'
  import SimpleLoaderDialog from '../components/simpleLoaderDialog'
  import DocsTable from '../components/tpreport/docsTable'
  import ReportPercentage from '../components/tpreport/reportPercentage'
  import PenaltyTable from '../components/tpreport/penaltyTable'
  export default {
    components: {
      PenaltyTable,
      ReportPercentage,
      DocsTable,
      SimpleLoaderDialog,
      BasicTable,
      TpMediaImages,
      AudioCard,
      VideoCard

    },
    data() {
        return {
          passwordDialog: true,
          deleteMode: false,
          error: false,
          loader: false,
          loaderText: 'Загрузка',
          snackbar: false,
          sendToAccountDialog: false,
          report: null,
          deal: null,
          dealID: null,
          tab: null,
          password: null,
          passwordCompare: false,
          mode: 'none'
        }
    },
    filters: {

    },
    computed: {
      filesInPoints() {
        if(this.report && this.report.points) {
          return this.report.points.filter(p => p.sto_file !== null)
        }
        return []
      },
      images () {
        let images = ['jpg', 'png', 'gif']
        if (this.report.files) {
          return this.report.files.filter(f => {
            let fname = f.name.split('.')
            let sname = fname[fname.length - 1].toLowerCase()
            return images.indexOf(sname) > -1 || f.type === 'image'
          })
        } else {
          return []
        }
      },
    },
    watch: {

    },
    methods: {
      async returnToFranch() {
        this.report.sendToAccount = false
        this.saveReport() //TODO: Расскоментить
      },
      async sendToAccount() {
        this.sendToAccountDialog = false

        this.Loader('Отправка сообщения менеджеру', true)
        const companyData = await this.$http.get(`${this.$store.getters.bxapi}crm.company.get?id=${this.deal.UF_CRM_1555309977}`)
        const mananagerId = companyData.data.result.ASSIGNED_BY_ID

        const sendMessage = await  this.$http.post(`${this.$store.getters.bxapi}im.notify`, {
          to: mananagerId,
          message: `Руководитель станции по адресу [b]${this.deal.UF_CRM_1555319274593}[/b] закончил комментировать Отчет тайной проверки #BR# Отчет по ссылке https://my.fitauto.ru/bx/shopper/${this.dealID} Пароль ${this.deal.UF_CRM_1575264324}`,
          type: 'SYSTEM'
        })
        this.snackbar = true
        this.Loader('Загрузка', false)
        this.report.sendToAccount = true
        this.saveReport() //TODO: Расскоментить
      },
      checkPassword() {
        if(this.password.toString() === this.deal.UF_CRM_1575264293.toString()) this.mode = 'franch'
        if(this.password.toString() === this.deal.UF_CRM_1575264324.toString()) this.mode = 'account'
        if(this.password.toString() === this.deal.UF_CRM_1576137828.toString()) this.mode = 'uk'
        if(this.mode === 'none') {
          this.passwordCompare = false
          this.passwordDialog = true
        } else {
          this.passwordCompare = true
          this.passwordDialog = false
        }
      },
      Loader: function (text, show = true) {
        this.loaderText = text
        this.loader = show
      },
      async getReport() {
        this.Loader('Загрузка', true)
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v3/bots/shopper/report/${this.dealID}`)
          if (!r.data.error) {
            console.log('we have report in db')
            this.report = JSON.parse(JSON.stringify(r.data.report))
            if(this.report.sendToAccount === undefined) this.report.sendToAccount = false
          } else {
            this.error = 'Произошла ошибка при загрузке отчета'
          }
        } catch (e) {
          console.log('e', e)
          this.error = 'Произошла ошибка при загрузке отчета'
        }
        this.Loader('Загрузка', false)
      },
      getDealID: function () {
        this.dealID = this.$route.params.dealid
      },
      getDealData: async function () {
        this.Loader('Загрузка', true)
        try {
          console.log('GET DEAL DATA')
          const r = await this.$http.get(`${this.$store.getters.bxapi}crm.deal.get?id=${this.dealID}`)
          if (!r.data.error) {
            this.deal = r.data.result
            console.log(r.data.result)
            console.log('RESULT')
          } else {
            console.log('ERROR')
            this.error = 'Данные об отчете не загрузились!'
          }
        } catch (e) {
          console.log('e', e)
          this.error = 'Данные об отчете не загрузились!'
        }
        console.log('GETTTT DEAL DATA')
        this.Loader('Загрузка', false)
      },
      saveReport: async function () {
        this.Loader('Сохранение отчета')
        //await pause(200)
        // TODO: заносим отчет в базу

        let object = {
          report: JSON.stringify(this.report),
          deal: this.dealID,
          sto: this.report.dealData.sto_id,
          test: this.report.testInspection
        }

        console.log('report', object)

        try {
          const r = await this.$http.post(`${this.$store.getters.api}v4/bots/shopper/report`, object)
        } catch (e) {
          console.log(e)
        }

        this.Loader(null, false)
        this.$nextTick(function () {
          console.log('report saved!', this.report)
        })

      },
    },
    async created () {
      this.$emit('maincomponenthooks', { hideAppBar: true })

    },
    async mounted () {
      this.getDealID()
      await this.getDealData()
      await this.getReport()
    }
  }
</script>
<style>
.rowBlock {
    background: #ffc107;
}
</style>